import { INumberFormat } from '@types'

export * from './cubeJs'
export * from './request'

export const roundTo = (num: number, digits: number) =>
  Math.round((num + Number.EPSILON) * Math.pow(10, digits)) /
  Math.pow(10, digits)

export const NumberFormatter = (
  num: number,
  method: INumberFormat,
  digits = 2
) => {
  if (num === 0) return 0
  const convertTable = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  if (method === 'EXP') {
    if (num < -99999) return num.toExponential(digits)
    if (num <= 0) return num
    if (num < 0.01) return num.toExponential(digits)
    if (num > 99999) return num.toExponential(digits)
    return num
  }

  let kMG = ''
  convertTable.forEach(({ value, symbol }) => {
    let fraction: number
    if (num < 0) {
      fraction = roundTo((num * -1) / value, digits)
    } else fraction = roundTo(num / value, digits)
    if (fraction > 1) {
      kMG = `${num < 0 ? '-' : ''}${fraction}${symbol}`
    }
  })
  return kMG
}

export const normalizeNumber = (value: number, minimumRange: number) => {
  return Math.log(value + Math.abs(minimumRange) + 0.1)
}

export const denormalizeNumber = (value: number, minimumRange = 0) => {
  if (minimumRange !== undefined)
    return Math.round(Math.exp(value) - Math.abs(minimumRange) - 0.1)
  else return value
}
